<template>
  <div>
    <div v-loading="g_loading" style="width: calc(100% - 10px);height:calc(100vh - 140px);">
      <SeeksRelationGraph ref="seeksRelationGraph" :options="graphOptions" :on-node-click="handleClickNode"/>
    </div>
  </div>
</template>

<script>
import SeeksRelationGraph from 'relation-graph'
export default {
  name: 'DrawTree',
  components: { SeeksRelationGraph },
  data() {
    return {
      g_loading: true,
      graphOptions: {
        'layouts': [
          {
            'label': '中心',
            'layoutName': 'tree',
            // 'layoutClassName': 'seeks-layout-tree',
            'defaultJunctionPoint': 'border',
            'defaultNodeShape': 0,
            'defaultLineShape': 1,
            // 'centerOffset_x':0,
            'centerOffset_y': -150,
            'min_per_width': '60',
            'min_per_height': '150',
            'max_per_height': '300'
          }
        ],
        "defaultExpandHolderPosition": "bottom",
        'defaultLineShape': 4,
        'defaultJunctionPoint': 'tb',
        'defaultNodeShape': 1,
        'defaultNodeWidth': '50',
        'defaultNodeHeight': '250',
        'defaultNodeBorderWidth': 0,
        'defaultNodeColor': "#f8e3c5",
        'defaultNodeFontColor': '#606266',
        'defaultLineColor': '#606266',
        'moveToCenterWhenResize': false,
        'allowShowMiniNameFilter': false,
      }
    }
  },
  created() {
  },
  mounted() {
    this.setGraphData({'rootId':1, 'nodes':[{'id':1, 'text':'', 'color':"white", 'width':100, 'height':50}], 'links':[]}, false)
  },
  methods: {
    // setGraphData 设置用于绘制树结构的数据
    //  Args:
    //    data: 数据
    //    differentColor: 是否对不同的节点使用不同的颜色
    setGraphData(data, differentColor) {
      // 需要对不同操作符使用不同的颜色
      this.setDiffColor(data, differentColor);

      // 绘制树形图
      setTimeout(function() {
        this.g_loading = false
        this.$refs.seeksRelationGraph.setJsonData(data, (seeksRGGraph) => {
          // 这些写上当图谱初始化完成后需要执行的代码
        })
      }.bind(this), 1000)
    },

    /**
     * handleClickNode 处理节点的点击事件，如果节点有额外信息，即 info 不为空，展示该信息
     * @param nodeObject 被点击的节点对象
     */
    handleClickNode(nodeObject, $event){
      let temp = localStorage.getItem("isEarlyAccess");
      console.log(temp);
      if(temp === "false"){
        return;
      }

      if (nodeObject.data.info !== '' && nodeObject.data.info !== undefined){
        this.$notify({
          title: 'Index Info',
          message: nodeObject.data.info,
          duration: 10000
        })
      } else {
        console.log("没有需要展示的数据: ", nodeObject.data.info)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
